import React from 'react';
import { Tooltip as AntdTooltip } from 'antd';

export interface TooltipProps {
  id?: string;
  title?: React.ReactNode;
  children: React.ReactNode;
  placement?:
    | 'top'
    | 'topLeft'
    | 'topRight'
    | 'bottom'
    | 'bottomLeft'
    | 'bottomRight'
    | 'left'
    | 'leftTop'
    | 'leftBottom'
    | 'right'
    | 'rightTop'
    | 'rightBottom';
  getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;
  rootClassName?: string;
  overlayStyle?: React.CSSProperties;
}

export const Tooltip = ({
  title,
  children,
  placement,
  id,
  getPopupContainer,
  rootClassName,
  overlayStyle,
}: TooltipProps) => {
  return (
    <AntdTooltip
      title={title}
      placement={placement}
      id={id}
      getPopupContainer={getPopupContainer}
      rootClassName={rootClassName}
      overlayStyle={overlayStyle}
    >
      {children}
    </AntdTooltip>
  );
};
